import { formSchemaStackOne } from "./formSchemaStackOne";
import { formSchemaStackThree } from "./formSchemaStackThree";
import { formSchemaStackTwo } from "./formSchemaStackTwo";

export const formSchema = {
  ...formSchemaStackOne,
  ...formSchemaStackTwo,
  ...formSchemaStackThree,
};
